import { Component, OnInit, ViewChild, NgZone, ChangeDetectorRef, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../_services/index';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from 'ng2-translate';
import * as firebase from 'firebase';
import { AngularFireAuth } from 'angularfire2/auth';
import { NgModel, Validators } from '@angular/forms';
import { DownloadImageService } from '../../_services/download-image.service';
import { FirebaseError } from 'firebase';
import { ScriptLoaderService } from '../../_services/script-loader.service';
import { NgbTabset } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from '../../_services/user.service';
import { MatDialog } from '@angular/material';
import { AgreementComponent } from '../../directive/agreement/agreement.component';
import { ImageToDataUrlService } from '../../_services/image-to-data-url/image-to-data-url.service';
import { ResizeOptions } from '../../_services/image-to-data-url/interfaces';
import { ApiService } from '../../_services/api.service';
import { BadwordsService } from '../../_services/badwords.service';
import { AngularFirestore } from 'angularfire2/firestore';
import { Http } from '@angular/http';
@Component({
  selector: 'register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  loginModel: any = {};
  auhtModel: any = {};
  registerModel: any = {
    day: 'Gün',
    month: 'Ay',
    year: 'Yıl',
    point: {
      totalPoint: 0
    },
    level: 0,
    profileImage: 'no-image.png',
    isSecret: false
  };
  authModel: any = {
    agreement: [false, Validators.required],
    password: ['', Validators.required],
    confirmPassword: ['', Validators.required]
  }
  loading = false;
  returnUrl: string;
  alert: any = {};
  response: any;
  user: any;
  uid: string;
  oobCode: any;
  ipAddress: any;
  lastUser;
  blacklist = false;
  staticAlertClosed = false;
  isElder = false;
  @ViewChild('username') public username: NgModel;
  @ViewChild('firstname') public firstname: NgModel;
  @ViewChild('lastname') public lastname: NgModel;
  @ViewChild('tabset') tabset: NgbTabset;
  @ViewChild('loginUsername') loginUsername: ElementRef;
  @ViewChild('loginPassword') loginPassword: ElementRef;
  private subscription: Subscription = new Subscription();
  private subscription2: Subscription = new Subscription();
  forgotPassword = false;
  days = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15',
    '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
  months = [
    { month: 'Ocak', value: '01' },
    { month: 'Şubat', value: '02' },
    { month: 'Mart', value: '03' },
    { month: 'Nisan', value: '04' },
    { month: 'Mayıs', value: '05' },
    { month: 'Haziran', value: '06' },
    { month: 'Temmuz', value: '07' },
    { month: 'Ağustos', value: '08' },
    { month: 'Eylül', value: '09' },
    { month: 'Ekim', value: '10' },
    { month: 'Kasım', value: '11' },
    { month: 'Aralık', value: '12' }];
  years = [];
  emailTemplate: any = {};
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private imageResize: ImageToDataUrlService,
    public translate: TranslateService,
    private cd: ChangeDetectorRef,
    private _http: Http,
    public dialog: MatDialog,
    public afAuth: AngularFireAuth,
    private scriptLoader: ScriptLoaderService,
    private downloadImageService: DownloadImageService,
    private zone: NgZone,
    private badwordsService: BadwordsService,
    private afs: AngularFirestore,
    private apiService: ApiService,
    private userService: UserService) {
    this.getIpAdress();

    let dateNow = new Date();
    let currentYear = dateNow.getFullYear();
    for (let i = currentYear - 100; i < currentYear; i++) {
      this.years.push(i);
    }
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('tr');
    // let lang = navigator.language;
    //// the lang to use, if the lang isn't available, it will use the current loader to get them
    // translate.use(lang);
    // });
    setInterval(() => {
      try {
        this.loginModel.username = this.loginUsername.nativeElement.value;
        this.loginModel.password = this.loginPassword.nativeElement.value;
      } catch (e) { }

    }, 500);
  }

  signUpWithGoogle() {
    let loginProvider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(loginProvider).then(res => {
      this.loading = true;
      this.userService.userLog('login', this.ipAddress);
      this.signUpWithSocialIcon(res.user);



    }).catch(err => this.authErrors(err));
  }

  signUpWithFacebook() {
    let loginProvider = new firebase.auth.FacebookAuthProvider();
    firebase.auth().signInWithPopup(loginProvider).then(res => {
      this.loading = true;
      this.userService.userLog('login', this.ipAddress);
      this.signUpWithSocialIcon(res.user);

    }).catch(err => this.authErrors(err))
  }
  closeAlert() {
    this.staticAlertClosed = false;
    try { this.cd.markForCheck() } catch (e) { }
  }

  signUpWithSocialIcon(data) {
    localStorage.setItem("currentUserId", data.uid);
    this.userService.setUser(data.uid);
    var user: any = {};

    this.afs.collection('users').doc(data.uid).ref.get().then(username => {
      var x = username.data();

      if (x) {

        this.zone.run(() => this.router.navigate([this.returnUrl]));
      }
      else {
        this.loading = true;
        Object.assign(user, this.registerModel);
        user.firstname = data.displayName.substring(0, data.displayName.lastIndexOf(' '));
        user.lastname = data.displayName.substring(data.displayName.lastIndexOf(' '));
        user.email = data.email;
        user.username = user.firstname.replace(/\s/g, "") + Date.now();
        this.returnUrl = "auth/saveUsername";
        return this.downloadUserProfileImage(data.photoURL).then(image => {
          if (image) {
            user.profileImage = data.uid + '%2FprofileImage';
            return this.register(user);
          }
        }).catch(err => {
          return this.register(user);
        });

      }

    })
  }
  public blobToFile = (theBlob: Blob, fileName: string): File => {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return <File>theBlob;
  }
  downloadUserProfileImage(imageURL): Promise<any> {
    const currentUserId = this.userService.getUid();
    return new Promise((resolve, reject) => {
      this.subscription.add(this.downloadImageService.getImage(imageURL).subscribe(image => {
        this.downloadImageService.upload(new Blob([new Uint8Array(image)]), currentUserId).then(res => {
          let resizeOptions: ResizeOptions[] = [{
            maxHeight: 128,
            maxWidth: 128
          }, {
            maxHeight: 64,
            maxWidth: 64
          }, {
            maxHeight: 45,
            maxWidth: 45
          }];
          let count = 0;
          resizeOptions.forEach(option => {
            this.imageResize.readFiles([this.blobToFile(new Blob([new Uint8Array(image)]), "profileImage_" + option.maxHeight + "_thumb")], { resize: option }, imageResult => {
              if (imageResult.error) alert(imageResult.error);
              let src = imageResult.resized
                && imageResult.resized.dataURL
                || imageResult.dataURL;
              firebase.storage().ref('/files/' + currentUserId).child("profileImage_" + option.maxHeight + "_thumb").putString(src, "data_url").then(() => {
                if (++count == resizeOptions.length) resolve(currentUserId + '%2FprofileImage');
              });
            });
          })
        }).catch(err => {
          reject(err);
        });
      }))
    });
  }

  ngOnInit() {
    // reset login status
    firebase.auth().signOut();
    // localStorage.clear();
    this.authenticationService.logout();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
    this.subscription.add(this.route.queryParams.subscribe(params => {
      this.oobCode = params["oobCode"];
      if (this.oobCode) {
        firebase.auth().applyActionCode(this.oobCode);
      }
    }))

  }
  authErrors(err: FirebaseError) {
    this.staticAlertClosed = true;
    switch (err.code) {
      case "auth/user-not-found": this.alert = { type: "danger", message: "Emin misin? Platformda böyle bir kullanıcı yok." }; break;
      // case "auth/invalid-email": this.alert = { type: "danger", message: "E-posta adresin hatalı" }; break;
      case "auth/wrong-password": this.alert = { type: "danger", message: "Parolan geçersiz veya henüz şifren yok." }; break;
      case "auth/account-exists-with-different-credential": this.alert = { type: "danger", message: "Bu e-posta adresi zaten kullanılıyor." }; break;
      case "auth/email-already-in-use": this.alert = { type: "danger", message: "E-posta adresin, platformda başka bir kullanıcı tarafından kullanılıyor." }; break;
      default: this.alert = { type: "danger", message: "Bir hata oluştu, lütfen tekrar dene!" }; throw new Error(err.code);
    }
    this.loading = false;
    this.cd.markForCheck();
  }

  getIpAdress() {
    this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }

  login() {

    this.apiService.sqlGet('corporate/loginUsername?value=' + this.loginModel.username).toPromise().then((a => {


      if (a === 'user-not-found') {
        this.staticAlertClosed = true;
        this.alert = { type: "danger", message: "Emin misin? Platformda böyle bir kullanıcı yok." };
        this.loading = false;

      }
      else {


        this.staticAlertClosed = false;
        firebase.auth().signInWithEmailAndPassword(a, this.loginModel.password).then(data => {
          console.log(data.uid)


          this.userService.setUser(data.uid);
          localStorage.setItem("currentUserId", data.uid);
          this.zone.run(() => this.router.navigate([this.returnUrl])).then(() => {
            this.userService.userLog('login', this.ipAddress);
          });
          this.loading = true;



        }).catch(err => this.authErrors(err))

      }
    }));


  }

  usernameInputKeyUp(event: KeyboardEvent) {
    this.checkUsername(isExist => {
      if (isExist) {
        this.username.control.setErrors({ 'valid': false });
      }
    })
  }
  emailInputKeyUp(event: KeyboardEvent) {
    this.checkMail(isExist => {
      if (isExist) {
        this.username.control.setErrors({ 'valid': false });
      }
    })
  }
  checkMail(callback: (data: boolean) => void) {
    let user = this.afAuth.auth.fetchProvidersForEmail(this.registerModel.email);
    this.afAuth.auth
  }
  sendEmail() {
    this.userService.sendEmail(this.emailTemplate).then(() => this.alert = { type: "success", message: "Onay epostası gönderildi" });
  }
  checkUsername(callback: (data: boolean) => void) {

    if (this.registerModel.username) {
      this.afs.collection('entities').ref.where('uniqueName', '==', this.registerModel.username.toLowerCase()).get().then(snap => {

        if (snap) {
          callback(!snap.empty)
        }

      })
    }
  }
  checkBadWord() {
    if (this.subscription2) {
      this.subscription2.unsubscribe();
    }

    this.subscription2 = this.badwordsService.getBadwords().subscribe(badwords => {
      this.blacklist = false;
      badwords.forEach(badword => {
        if (this.registerModel.username == badword) {
          this.username.control.setErrors({ 'valid': false });
          this.blacklist = true;
        }
        else if (this.registerModel.firstname == badword) {
          this.firstname.control.setErrors({ 'valid': false });
          this.blacklist = true;
        }
        else if (this.registerModel.lastname == badword) {
          this.lastname.control.setErrors({ 'valid': false });
          this.blacklist = true;
        }

      })
      if (this.blacklist == false) {
        this.register()
      }
    })
  }

  onSubmit(form) {
    firebase.auth().sendPasswordResetEmail(form).then(data => {
      this.loading = false;
      this.forgotPassword = false;
      this.staticAlertClosed = true;
      this.alert = { type: "success", message: 'Aktivasyon linkiniz e-posta adresinize gönderilmiştir!' }
      this.cd.markForCheck();
      // this.alertService.success('Aktivasyon linkiniz e-posta adresinize gönderilmiştir!')
    }).catch(err => this.authErrors(err));
  }

  onlyNumberKey(event) {
    let key = event.keyCode || event.charCode;
    return key >= 48 && key <= 57;
  }

  onlyLetterKey(event) {
    let key = event.keyCode || event.charCode;
    return (key >= 65 && key <= 90) || (key >= 97 && key <= 122) || key == 95
      || key == 231
      || key == 32
      || key == 305
      || key == 287
      || key == 246
      || key == 351
      || key == 252
      || key == 199
      || key == 304
      || key == 208
      || key == 214
      || key == 350
      || key == 220;
  }

  onlyLetterKeyForUserName(event) {
    let key = event.keyCode || event.charCode;
    return (key >= 65 && key <= 90)
      || (key >= 97 && key <= 122)
      || (key >= 48 && key <= 57)
      || key == 95;
  }

  isElderlyFunc() {
    let time = new Date(this.registerModel.year + "-" + this.registerModel.month + "-" + this.registerModel.day);
    let age = Date.now() - Number(time);
    let ageGet = Math.floor(age / 1000 / 60 / 60 / 24 / 365.25);

    return ageGet < 18;

  }

  async register(model?) {
    if (this.blacklist == false)
      this.loading = true;
    var userInfo = model || this.registerModel;
    let modifyDate = Date.now();
    let welcomePost: any = {
      text: "Hoşgeldin " + userInfo.firstname + " " + userInfo.lastname + "😃",
      modifyDate: modifyDate,
      settings: {
        isOnlyFriend: false,
        isNameSecret: false,
        isGlobal: true,
        isAllowComments: false
      },
      author: {
        firstname: "bigadvice",
        lastname: "",
        username: "bigadvice",
        profileImage: "UserIcon.png"
      },
      valueOf: 0,
      order: -1 * modifyDate,
      username: userInfo.username.replace(/\s/g, "").toLowerCase()
    };
    userInfo.isEmailVerified = false;
    userInfo.username = userInfo.username.replace(/\s/g, "").toLowerCase();
    userInfo.joinDate = Date.now();
    userInfo.birthday = { day: this.registerModel.day, month: this.registerModel.month, year: this.registerModel.year }
    userInfo.userInfoPoints = {
      birthday: 0,
      city: 0,
      education: 0,
      about: 0,
      job: 0,
      gender: 0,
      importContact: 0,
      interested: 0
    };


    let update = {};


    let entitiesUserInfo = {
      name: userInfo.firstname + ' ' + userInfo.lastname,
      profileImage: userInfo.profileImage,
      searchTerm: (userInfo.username + userInfo.firstname + userInfo.lastname).toLowerCase().replace(/\s/g, ""),
      type: 'user',
      uniqueName: userInfo.username

    }


    if (localStorage.getItem("currentUserId") && this.blacklist == false) {
      userInfo.isNewRegistered = true;
      this.loading = false;
      this.afs.collection('users').doc(this.userService.getUid()).set(userInfo).then(() => {
        this.afs.collection('entities').add(entitiesUserInfo);
      })
        .then(() => {
          this.zone.run(() => {
            this.subscription = this.userService.getUser().subscribe(elem => {
              this.lastUser = elem;

            })

            var users = {
              userKey: localStorage.getItem("currentUserId"),
              agreement: this.lastUser.agreement || null,
              birthday: this.dateFormat(new Date(this.lastUser.birthday.year + "/" + this.lastUser.birthday.month + "/" + this.lastUser.birthday.day)),
              totalPoint: this.lastUser.point.totalPoint || null,
              username: this.lastUser.username,
              email: this.lastUser.email,
              firstname: this.lastUser.firstname,
              isEmailVerified: this.lastUser.isEmailVerified || null,
              isSecret: this.lastUser.isSecret || null,
              joinDate: this.dateFormat(new Date(this.lastUser.joinDate)),
              lastname: this.lastUser.lastname,
              level: this.lastUser.level,
              city: this.lastUser.city || null,
              phoneNumber: this.lastUser.phoneNumber || null,
              education: this.lastUser.education || null,
              gender: this.lastUser.gender || null,
              job: this.lastUser.job || null,
              profileImage: this.lastUser.profileImage || null,
              following: this.lastUser.following ? this.lastUser.following.length : 0,
              followers: this.lastUser.followers ? this.lastUser.followers.length : 0
            }

            this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise().then(a => console.log(a, 'api')).then(() => {
              this.router.navigate(["/auth/saveUsername"])
            })
          });


        });
    } else {
      return this.checkUsername(isExist => {
        if (!isExist) {
          var createAuth = firebase.auth().createUserWithEmailAndPassword(this.registerModel.email, this.auhtModel.password).catch(error => {
            this.authErrors(error);
            return;
          })
          var createUser = createAuth.then((data: any) => {
            this.userService.setUser(data.uid);
            this.loading = false;
            localStorage.setItem("currentUserId", data.uid);
            this.userService.setUser(data.uid);
            return this.afs.collection('users').doc(data.uid).set(userInfo).then(() => {
              this.afs.collection('entities').add(entitiesUserInfo);

            })
          }).then(() => {
            this.zone.run(() => {
              this.subscription = this.userService.getUser().subscribe(elem => {
                if (elem)
                  this.lastUser = elem;
              })



              var users = {
                userKey: localStorage.getItem("currentUserId"),
                agreement: this.lastUser.agreement || null,
                birthday: this.dateFormat(new Date(this.lastUser.birthday.year + "/" + this.lastUser.birthday.month + "/" + this.lastUser.birthday.day)),
                totalPoint: this.lastUser.point.totalPoint || null,
                username: this.lastUser.username,
                email: this.lastUser.email,
                firstname: this.lastUser.firstname,
                isEmailVerified: this.lastUser.isEmailVerified || null,
                isSecret: this.lastUser.isSecret || null,
                joinDate: this.dateFormat(new Date(this.lastUser.joinDate)),
                lastname: this.lastUser.lastname,
                level: this.lastUser.level,
                city: this.lastUser.city || null,
                phoneNumber: this.lastUser.phoneNumber || null,
                education: this.lastUser.education || null,
                gender: this.lastUser.gender || null,
                job: this.lastUser.job || null,
                profileImage: this.lastUser.profileImage || null,
                following: this.lastUser.following ? this.lastUser.following.length : 0,
                followers: this.lastUser.followers ? this.lastUser.followers.length : 0
              }
              this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).toPromise().then(a => a);
              this.router.navigate(["/auth/phoneNumber"]);

            })
          }).then(() => {
            this.afs.collection('welcomePosts').doc(localStorage.getItem('currentUserId')).set(welcomePost);
          })


        } else {
          this.username.control.setErrors({ 'valid': false });
          this.loading = false;
        }
      })
    }
  }
  dateFormat(data) {
    if (data.length == 10) {
      return data;
    }
    var dd = data.getDate();
    var mm = data.getMonth() + 1; //January is 0!
    var yyyy = data.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    data = yyyy + '-' + mm + '-' + dd;
    return data;
  }
  openAgreement(type) {
    this.dialog.open(AgreementComponent, {
      width: '69%',
      height: '82%',
      data: {
        type: type
      }
    });
  }

  ngAfterViewInit() {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.subscription.add(this.route.queryParamMap.subscribe(params => {
      let queryString = this.route.snapshot.queryParams['type'];
      if (queryString == 'login') {
        this.tabset.select("login");
      }
    }));
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription2.unsubscribe();
  }
}






// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/auth/register/register.component.ts